import * as types from '../constants/ActionTypes';
import { merge, objOf, omit } from 'ramda';

const initialState = {};

/**
 * State is a mapping of API action to the error message from the API.
 *
 * Example State:
 * {
 *   START_CHANNEL: "Another room exists with that name",
 *   DOWNLOAD_ATTACHMENT: "Unable to download attachment"
 * }
 */
const errors = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_ERROR: {
      const { type, reason } = action.payload;
      return merge(state, objOf(type, reason));
    }
    case types.CLEAR_ERROR: {
      const { type } = action.payload;
      return state[type] ? omit([type], state) : state;
    }
    default:
      return state;
  }
};

export default errors;
